export const fallbackLabel = (value, fallback = 'Não informado') =>
  value || fallback;

export const toText = value => String(value || '').trim();

export const numberValue = value => {
  if (value === '' || value === null || value === undefined) return null;
  const normalized = Number(value);
  return Number.isFinite(normalized) ? normalized : null;
};
